import { Injectable } from "@angular/core";
import { UserService } from "../user.service";
import { ServerRoutes } from "src/app/ServerRoutes";
import { HttpClient } from "@angular/common/http";

@Injectable({
	providedIn: "root",
})
export class PlanService {
	constructor(
		private http: HttpClient,
		private routes: ServerRoutes,
		private userService: UserService
	) {}

	getUserPlans (id) {
		return this.routes.requisicaoHTTP(
			this.http.get(
				this.routes.getUserPlans(id),
				this.userService.getHeader()
			)
		);
	}

	getTypePlans () {
		return this.routes.requisicaoHTTP(
			this.http.get(
				this.routes.getTypePlans(),
				this.userService.getHeader()
			)
		);
	}

	getPlanByTypeId (typeId) {
		return this.routes.requisicaoHTTP(
			this.http.get(
				this.routes.getPlanByTypeId(typeId),
				this.userService.getHeader()
			)
		);
	}

	getBoletoUrl (transactionPagarmeId) {
		return this.routes.requisicaoHTTP(
			this.http.get(
				this.routes.getBoletoUrl(transactionPagarmeId),
				this.userService.getHeader()
			)
		);
	}

	getPaymentPlan (professionalPlanId) {
		return this.routes.requisicaoHTTP(
			this.http.get(
				this.routes.getPaymentPlan(professionalPlanId),
				this.userService.getHeader()
			)
		);
	}

	newPlan (data) {
		return this.routes.requisicaoHTTP(
			this.http.post(
				this.routes.newPlan,
				data,
				this.userService.getHeader()
			)
		);
	}

	newPlanRecurrent (data) {
		return this.routes.requisicaoHTTP(
			this.http.post(
				this.routes.newPlanRecurrent,
				data,
				this.userService.getHeader()
			)
		);
	}
}
